"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidInput = exports.format = exports.MonthInput = exports.MonthField = void 0;
var react_1 = __importStar(require("react"));
var react_popper_1 = require("react-popper");
var createAutoCorrectedDatePipe_1 = __importDefault(require("text-mask-addons/dist/createAutoCorrectedDatePipe"));
var useStyles_1 = require("../../styles/hooks/useStyles");
var react_2 = require("../../util/react");
var FocusManagerContainer_1 = require("../FocusManagerContainer");
var MaskedTextField_1 = require("../MaskedTextField");
var MonthPicker_1 = require("../MonthPicker");
function MonthField(props) {
    var value = props.value, popperProps = props.popperProps, inputRef = props.inputRef, onChange = props.onChange, onIconClick = props.onIconClick, rest = __rest(props, ["value", "popperProps", "inputRef", "onChange", "onIconClick"]);
    var _a = useStyles_1.useStyles(createStyles), classes = _a.classes, css = _a.css;
    var _b = react_1.useState(false), open = _b[0], setOpen = _b[1];
    var _c = react_1.useState(), anchorRef = _c[0], setAnchorRef = _c[1];
    var _d = react_1.useState(), popperRef = _d[0], setPopperRef = _d[1];
    var _e = react_popper_1.usePopper(anchorRef, popperRef, __assign(__assign({}, popperProps), { placement: 'bottom-start' })), popperStyle = _e.styles.popper, placement = _e.attributes.placement;
    var handlePickerChange = function (referenceMonth) {
        setOpen(false);
        onChange(referenceMonth);
    };
    var handleInputChange = function (e) {
        if (e && e.target && e.target.value) {
            var val = e.target.value;
            if (exports.isValidInput(val)) {
                onChange({ month: +val.substr(0, 2) - 1, year: +val.substr(3) });
            }
        }
        else {
            onChange(null);
        }
    };
    var handleInputIconClick = function () { return setOpen(true); };
    var handleFocusIn = function () { return setOpen(true); };
    var handleFocusOut = function () { return setOpen(false); };
    return (react_1.default.createElement(FocusManagerContainer_1.FocusManagerContainer, { onFocusIn: handleFocusIn, onFocusOut: handleFocusOut },
        react_1.default.createElement(MonthInput, __assign({ inputRef: react_2.composeRefs(setAnchorRef, inputRef), value: exports.format(value), icon: 'calendarOutline', onIconClick: react_2.composeHandlers(handleInputIconClick, onIconClick), onChange: handleInputChange }, rest)),
        open && (react_1.default.createElement("div", { ref: setPopperRef, className: css(classes.popup, popperStyle), "data-placement": placement, "data-testid": 'MonthField.popup' },
            react_1.default.createElement(MonthPicker_1.MonthPicker, { month: value && value.month, year: value && value.year, onChange: handlePickerChange })))));
}
exports.MonthField = MonthField;
function MonthInput(props) {
    return (react_1.default.createElement(MaskedTextField_1.MaskedTextField, __assign({ mask: [/\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/], pipe: createAutoCorrectedDatePipe_1.default('mm/yyyy'), placeholder: 'mm/yyyy' }, props)));
}
exports.MonthInput = MonthInput;
exports.format = function (value) {
    if (!value || !value.year || value.month == null) {
        return null;
    }
    if (value.month < 9) {
        return "0" + (value.month + 1) + "/" + value.year;
    }
    else {
        return value.month + 1 + "/" + value.year;
    }
};
exports.isValidInput = function (value) {
    return /\d\d\/\d\d\d\d/.test(value);
};
var createStyles = function (theme) { return ({
    popup: {
        zIndex: theme.zIndex.popper,
    },
}); };
//# sourceMappingURL=MonthField.js.map